import type { FaireProductEntity } from "../../entity_types/product";

export const p_f7drbc4jgz: FaireProductEntity = {
  token: "p_f7drbc4jgz",
  type: "product",
  name: "Off Leash Little Stickies",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/7419f411c617a1e6e9af6f4b150f09652595a47caff576e5f5212c4738006851.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ab1a0754d5d4de047a178f92c7a55fbcceb9987ac14bd382924fdb02b577d84d.jpeg",
    "https://cdn.faire.com/fastly/799e993710af00666a65c5dd9af84b8fdac5db87e181f796ae8469d018bd748f.jpeg",
    "https://cdn.faire.com/fastly/d569548f99be49b6579983338ca9d67b6a630e9faa0ca76625efc51a7d819958.jpeg",
    "https://cdn.faire.com/fastly/34841fa5f25d09cdf13ec624c75651efa31ebee43d703dc5e34eef6811321ac8.png",
  ],
  priceDollars: 5,
  description:
    "Because sometimes you need a little adhesive! Sweet watercolor illustrations bring joy to everyday tasks - perfect for your desk, home, bathroom mirrors, foreheads. The best part? They’re made in partnership with 3M, which means you get that classic Post-it® Notes stickiness that actually sticks!",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:01.751Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
